/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Icsrm_Online_Digital18Inputs */

const en__field_enum_icsrm_online_digital18 = /** @type {(inputs: _Field_Enum_Icsrm_Online_Digital18Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`online`)
};

const de__field_enum_icsrm_online_digital18 = /** @type {(inputs: _Field_Enum_Icsrm_Online_Digital18Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`online`)
};

/**
* | output |
* | --- |
* | "online" |
*
* @param {_Field_Enum_Icsrm_Online_Digital18Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_icsrm_online_digital18 = /** @type {((inputs?: _Field_Enum_Icsrm_Online_Digital18Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Icsrm_Online_Digital18Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_icsrm_online_digital18(inputs)
	return de__field_enum_icsrm_online_digital18(inputs)
});
export { _field_enum_icsrm_online_digital18 as "_field_enum_ICSRM_ONLINE_DIGITAL" }